<script setup>
import Right from 'assets/icons/right.svg'
import ShadowContentBox from '~/components/Modules/ShadowContentBox.vue'

const props = defineProps({
    userAccountOverviewItemConfig: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                label: rawValue => rawValue.label === undefined || typeof rawValue.label === 'string',
                fn: rawValue => rawValue.fn === undefined || typeof rawValue.fn === 'function',
                restricted: rawValue => rawValue.restricted === undefined || typeof rawValue.restricted === 'boolean',
                loginStatus: rawValue => rawValue.loginStatus === undefined || typeof rawValue.loginStatus === 'boolean',
                icon: rawValue => rawValue.icon === undefined || typeof rawValue.icon === 'object'
            }

            return Object.entries(validations).every(([_, validate]) => validate(rawValue))
        }
    }
})

const protectedItems = computed(() => !props?.userAccountOverviewItemConfig?.restricted || props?.userAccountOverviewItemConfig?.loginStatus)
</script>

<template>
    <ShadowContentBox v-if="protectedItems" class="account-overview-item" @click="userAccountOverviewItemConfig?.fn">
        <div class="account-overview-item-content">
            <div class="account-overview-text">
                <IconWrap>
                    <component :is="userAccountOverviewItemConfig?.icon" />
                </IconWrap>
                {{ userAccountOverviewItemConfig.label }}
            </div>
            <Right class="account-overview-action-icon" />
        </div>
    </ShadowContentBox>
</template>

<style lang="scss">
.account-overview-item {
    padding: 16px 24px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: px2rem(14);
    line-height: px2rem(24);
}

.account-overview-item-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: inherit;
    text-decoration: none;
}

.account-overview-text {
    display: flex;
    align-items: center;
}

.account-overview-action-icon {
    height: 14px;
    width: 8px;
}
</style>
